import {
  CourseCurriculum,
  CurriculumCourseStatus,
  useGetListCourseBySortLevelIdLazyQuery,
} from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";

type Props = {
  usedCoursesId: string[];
  levelId: string;
};
const useGetFilteredCoursesForSelect = ({ usedCoursesId, levelId }: Props) => {
  const [getCourses, { data, loading, fetchMore }] =
    useGetListCourseBySortLevelIdLazyQuery({
      variables: {
        page: 0,
        count: 25,
        status: CurriculumCourseStatus.Active,
        LevelId: levelId,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    getCourses();
  }, []);

  const filteredCourses = [
    ...get(data, "EducationGetter.getListCourseBySortLevelId.items", []).map(
      ({ id, code, certificateValidityPeriod, codeIS }: CourseCurriculum) => {
        return {
          value: id,
          label: `${codeIS}. ${code}`,
          isDisabled: usedCoursesId.includes(id),
          certificateValidityPeriod,
        };
      }
    ),
  ];

  const intersectionObserver = () => {
    if (filteredCourses.length < 25) {
      return;
    }
    const page = Math.ceil(filteredCourses.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ EducationGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { EducationGetter };
        }
        return {
          EducationGetter: {
            ...EducationGetter,
            getListCourseBySortLevelId: {
              ...EducationGetter.getListCourseBySortLevelId,
              items: [
                ...EducationGetter.getListCourseBySortLevelId.items,
                ...get(
                  fetchMoreResult,
                  "EducationGetter.getListCourseBySortLevelId.items",
                  []
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchText = debounce((searchText: string) => {
    getCourses({
      variables: {
        page: 0,
        LevelId: levelId,
        name: searchText,
      },
    });
  });

  return {
    filteredCourses,
    intersectionObserverCourseId: intersectionObserver,
    searchTextCourseId: searchText,
    loadingCourseId: loading,
  };
};

export default useGetFilteredCoursesForSelect;
